import { QuickActionsConstants } from '../store/quickActions.constants'
import { takeLatest } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { getUserIdSelector } from '../../user/selectors'
import {
  setAssessedBy,
  setDateTime,
  setSuccessfulAttempt,
} from '../../procedures/ventricularAssistDevice/store/ventricularAssistDevice.actions'
import { IVitalOptionsState } from '../../options/store/options.types'
import { getVitalOptionsSelector } from '../../options/selectors'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'

export function* setVentricularAssistDeviceQuickAction() {
  try {
    const userId: string = yield select(getUserIdSelector)
    const quickActionsObject = yield select(getQuickActionsSelector)
    const vitalsOptionsState: IVitalOptionsState = yield select(getVitalOptionsSelector)
    const { selectedQuickActionButton } = quickActionsObject
    const { props } = selectedQuickActionButton
    const { savedTimeString, currentDate } = props
    const { assessedByOptions } = vitalsOptionsState
    const assessedByOption = assessedByOptions.find((option) => option.id === +userId)
    yield put(setDateTime(savedTimeString, currentDate))
    yield put(setAssessedBy(assessedByOption ? assessedByOption : null))
    yield put(setSuccessfulAttempt(true))
  } catch (e) {
    yield put(throwPcrException(`setVentricularAssistDeviceQuickAction() error: ${e}`))
  }
}

export function* setVentricularAssistDeviceQuickActionSaga() {
  yield takeLatest(
    [QuickActionsConstants.SET_IS_VENTRICULAR_ASSIST_DEVICE_BUTTON_TYPE],
    performWithMutexHOG,
    setVentricularAssistDeviceQuickAction
  )
}
